import { ComponentStyleConfig } from '@chakra-ui/react';

export const Radio: ComponentStyleConfig = {
  baseStyle: {
    control: {
      borderColor: 'M.50',
      _checked: {
        color: 'iconAccent',
        borderColor: 'iconAccent',
        bg: 'white',
        _disabled: {
          color: 'iconAccent',
          borderColor: 'iconAccent',
        },
        _before: {
          w: 3,
          h: 3,
        },
      },
      _hover: {
        borderColor: 'iconAccent',
        _disabled: {
          borderColor: 'borderSubdued',
        },
        _checked: {
          bg: 'white',
          borderColor: 'iconAccent',
        },
      },
      _disabled: {
        cursor: 'default',
        bg: 'white',
        opacity: 0.36,
        borderColor: 'borderSubdued',
      },
      _focus: {
        borderColor: 'iconAccent',
        ' .chakra-checkbox__control': {
          borderColor: 'iconAccent',
        },
      },
    },
    container: {
      _disabled: {
        cursor: 'default',
      },
    },
  },
  variants: {
    contained: {
      container: {
        bg: 'M.20',
        ' .chakra-checkbox__control': {
          transition: 'border-color 0.2s ease-in-out',
        },
        transition: 'border-color 0.2s ease-in-out',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        border: '1px solid',
        borderColor: 'borderBase',
        borderRadius: 4,
        height: '48px',
        px: 4,
        '@media (hover: hover)': {
          _hover: {
            borderColor: 'iconAccent',
            bg: 'B.20',
            ' .chakra-radio__control, .chakra-checkbox__control': {
              borderColor: 'iconAccent',
            },
            _disabled: {
              cursor: 'default',
              borderColor: 'borderSubdued',
              ' .chakra-radio__control, .chakra-checkbox__control': {
                borderColor: 'borderSubdued',
              },
            },
          },
        },
        _checked: {
          borderColor: 'iconAccent',
          bg: 'B.20',
          _disabled: {
            cursor: 'default',
            borderColor: 'iconAccent',
            bg: 'B.20',
            ' .chakra-radio__control, .chakra-checkbox__control': {
              borderColor: 'iconAccent',
              bg: 'B.20',
            },
          },
        },
      },
      control: {
        transition: 'border-color 0.2s ease-in-out',
      },
      label: {
        margin: 0,
        fontWeight: 600,
        color: 'textBase',
      },
    },
  },
  sizes: {
    md: {
      control: { w: '5', h: '5' },
      label: { fontSize: 'sm' },
    },
  },
};
